const select = document.querySelector('.js-mobile-language-selector');

if (select) {
  select.addEventListener('change', () => {
    window.location = select[select.selectedIndex].value;
  });
}




// WEBPACK FOOTER //
// ./src/js/language-selector.js